import { yup } from '@framework/validation/initYup.ts';

export interface ITableSaveDirective {
  /**
   * Nome del campo da utilizzare per il salvataggio del valore in tabella
   */
  name?: string | null;
}

const TABLE_PLACEHOLDER_REGEX = /^\$\$[a-zA-Z0-9_-]+\.[a-zA-Z0-9_.-]+\$\$$/;

export const TableSaveDirectiveSchema: yup.ObjectSchema<ITableSaveDirective> =
  yup
    .object({
      name: yup
        .string()
        .matches(
          TABLE_PLACEHOLDER_REGEX,
          'Il nome del campo della tabella deve avere il formato $$tabella.campo$$',
        )
        .notRequired()
        .label('Nome campo tabella'),
    })
    .noUnknown();
